module.exports = __webpack_public_path__ + "static/media/phone-call2.e2de69bc.svg";